import { uiTokens } from '#src/assets/ui/shared/styles.ts'

function applyStyles(
  element: HTMLElement,
  styles: Record<string, string | number>,
) {
  Object.assign(element.style, styles)
}

export function createShadowMount(): {
  host: HTMLElement
  container: HTMLElement
} {
  const host = document.createElement('div')
  host.id = 'lcc-custom-ui-host'
  applyStyles(host, {
    display: 'block',
    position: 'fixed',
    inset: 0,
    width: 0,
    height: 0,
    overflow: 'visible',
    zIndex: uiTokens.zIndex.max,
    color: uiTokens.colors.gray900,
    fontFamily: `var(--cc-font-family, ${uiTokens.fontFamily})`,
  })

  const shadowRoot = host.attachShadow({ mode: 'open' })

  const style = document.createElement('style')
  style.textContent = `
    *, *::before, *::after {
      box-sizing: border-box;
      font-family: inherit;
    }

    button {
      font: inherit;
    }
  `
  shadowRoot.append(style)

  const container = document.createElement('div')
  applyStyles(container, {
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    color: 'inherit',
  })
  shadowRoot.append(container)
  document.body.append(host)

  return { host, container }
}
